<template>
  <div>
    <div
      class="h-[50px] w-full bg-cyan-100 flex justify-between items-center py-5 px-2"
    >
      <div>
        <input
          type="text"
          id="first_name"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          placeholder="Search Unique ID"
        />
      </div>
      <div>
        <button>All</button>
        <button>Printed</button>
        <button>Not Printed</button>
      </div>
      <div class="flex justify-center items-center gap-4">
        <button
          class="px-5 py-2 rounded-md bg-orange-500 text-black font-semibold hover:bg-orange-600 hover:text-white"
        >
          Print Selected
        </button>
        <button
          class="px-5 py-2 rounded-md bg-blue-500 text-black font-semibold hover:bg-blue-600 hover:text-white"
        >
          Upload
        </button>
        <button
          class="px-5 py-2 rounded-md bg-green-500 text-black font-semibold hover:bg-green-600 hover:text-white"
        >
          Export
        </button>
      </div>
    </div>
  </div>
</template>

<script></script>
